module.exports = __webpack_public_path__ + "img/card-4.d4b6e121.svg";